module.exports = __webpack_public_path__ + "img/188.aea63042.png";